<script lang="ts">
    import {SummarySectionType} from 'src/features/erp-sutor/features/attendance-calendar';
    import AttendanceSummarySection from '../AttendanceSummarySection.svelte';
    import AttendanceCell from '../../AttendanceCell.svelte';
    import AttendanceSummaryColumn from '../AttendanceSummaryColumn.svelte';

    export let includeSummaryStates = false;
</script>

<AttendanceSummarySection type={SummarySectionType.SECTION_LEGEND}>
    <AttendanceSummaryColumn>
        <AttendanceCell header></AttendanceCell>
        <AttendanceCell>
            <span class="legend-label">Náklady:</span>
        </AttendanceCell>
        <AttendanceCell>
            <span class="legend-label">PwK:</span>
        </AttendanceCell>
        <AttendanceCell>
            <span class="legend-label">Uznáno:</span>
        </AttendanceCell>

        {#if includeSummaryStates}
            <AttendanceCell>
                <span class="legend-label">Stav proplacení:</span>
            </AttendanceCell>
        {/if}
    </AttendanceSummaryColumn>
</AttendanceSummarySection>

<style lang="less">
    @import (reference) "styles/portaro.themes.less";

    .legend-label {
        color: @themed-text-muted;
    }
</style>